import { toast } from "sonner";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

export const useErrorListener = ({
  error,
  duration = 5000,
}: {
  error: any;
  duration?: number;
}) => {
  const { t } = useTranslation();

  useEffect(() => {
    if (error) {
      toast.error(t((error?.detail || error) as string), {
        duration,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error]);
};

export default useErrorListener;
